import React from 'react';
import { useMobileMenu } from '../contexts/MobileMenuContext';
import './MobileOverlay.css';

const MobileOverlay = () => {
  const { isMobileMenuOpen, toggleMobileMenu } = useMobileMenu();
  
  if (!isMobileMenuOpen) return null;
  
  return (
    <div className={`mobile-overlay ${isMobileMenuOpen ? 'show' : ''}`} onClick={toggleMobileMenu}></div>
  );
};

export default MobileOverlay; 